import UserPrivateComponent from "@/components/PrivacyComponent/UserPrivateComponent";
import { useAddDegreeMutation } from "@/redux/rtk/features/degree/degreeApi";
import { useTranslation } from "react-i18next";

import { Button, Form, Input } from "antd";

export default function AddDegree({ onClose }) {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const [addDegree, { isLoading }] = useAddDegreeMutation();

  const onFinish = async (values) => {
    const formData = {
      ...values,
    };

    const resp = await addDegree(formData);
    if (resp.data) {
      form.resetFields();
      if (onClose) onClose();
    }
  };

  return (
    <div className="flex justify-center mt-5">
      <UserPrivateComponent permission="create-degree">
        <Form
          className="w-full"
          onFinish={onFinish}
          colon={false}
          layout="vertical"
          form={form}>
          <div className="w-full px-10">
            <Form.Item
              label={t("degree.name")}
              name="name"
              rules={[
                { required: true, message: t("degree.nameRequired") || "Please enter degree name" },
              ]}>
              <Input placeholder={t("degree.name")} />
            </Form.Item>
          </div>

          <Form.Item label="" className="px-10">
            <div className="flex items-center gap-2">
              <Button
                size={"large"}
                htmlType="submit"
                type="primary"
                loading={isLoading}>
                {t("common.create")}
              </Button>
            </div>
          </Form.Item>
        </Form>
      </UserPrivateComponent>
    </div>
  );
}
